import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full flex-col gap-5',
    topSection: 'flex flex-col gap-3 px-3 lg:px-16',
    title: 'text-2xl leading-[140%] font-medium lg:text-3xl',
    subtitle: 'leading-[140%]',
    shippingCity:
      'text-s trading-[0.06%] text-text-main hover:text-brand-300 leading-[120%] font-medium uppercase hover:cursor-pointer',
    shippingCharacteristics: 'flex flex-col gap-[16px] px-3 lg:px-16',
    characteristic:
      'flex w-full max-w-screen flex-col gap-2 text-xs leading-[140%]',
    characteristicLabel:
      'heading-xs lg:heading-xs text-bg-items-black flex grow items-baseline text-xs leading-[140%] whitespace-nowrap after:mx-3 after:block after:h-[4px] after:w-full after:bg-[linear-gradient(90deg,#747d81_0%,#747d81_33.33%,transparent_33.33%,transparent_100%)] after:[background-size:6px_1px] after:bg-bottom after:bg-repeat-x',
    characteristicValue: 'heading-xs-intr max-w-[60%] font-medium',
    characteristicItem: '!md:py-0 !border-b-[0px] !py-0',
    shippingCharacteristicsTitle:
      'text-m trading-[0.02%] leading-[140%] font-[300]',
    pickupPoints: 'flex flex-grow flex-col gap-[24px] max-md:-mx-3',
    pickupPointsTitle: 'px-3 pt-3 text-xl leading-[140%] font-medium lg:px-16',
    loading: 'loading mt-5'
  }
});
